// File: loadBlatant - registers the Blatant display font for the model picker
// Created: 2026-11-03
// Author: Erick Hernández Silva
//
// Blatant (Tomas Castiglioni). Font files live in each stage's S3 bucket under
// fonts/ (prod) or preview/fonts/ (dev); the prod bucket allows CORS from *.
// NOTE: the files received ship with a TRIAL license — the client must hold a
// commercial web license for production use.

import { IS_PREVIEW } from '../../config.js';

const FONT_BASE = IS_PREVIEW
  ? 'https://touring-configurator-dev.s3.us-east-2.amazonaws.com/preview/fonts'
  : 'https://touring-configurator-prod.s3.us-east-2.amazonaws.com/fonts';

export const BLATANT_ENABLED = true;
export const BLATANT_FAMILY = "'Blatant', 'Bounded', Impact, 'Arial Black', sans-serif";

/**
 * @font-face must live in the document (not the shadow root) to be usable
 * inside our Shadow DOM, so it is injected into <head> once.
 */
export function loadBlatant(): void {
  if (!BLATANT_ENABLED || typeof document === 'undefined' || document.getElementById('cfg-font-blatant')) return;
  const face = (file: string, weight: number) =>
    `@font-face{font-family:'Blatant';font-style:normal;font-weight:${weight};font-display:swap;` +
    `src:url('${FONT_BASE}/${file}') format('opentype');}`;
  const style = document.createElement('style');
  style.id = 'cfg-font-blatant';
  style.textContent = face('Blatant.otf', 400) + face('Blatant-Bold.otf', 700);
  document.head.appendChild(style);
}
